export default (step, label) => {
  return {
    event: 'OTP_enrollment',
    eventCategory: 'OTP_enrollment',
    eventAction: step,
    eventLabel: label,
  };
};